// extracted by mini-css-extract-plugin
export default {"tabs":"g_s","tab-list":"g_t","tab":"g_v","active":"g_w"};